module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "70px",
      "height": "70px",
      "viewBox": "0 0 70 70",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Symbols",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "ICON:-Celebrate",
      "fill": "#050C14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M43.2790698,39.4412331 C43.5312292,38.2350308 43.7327796,37.3739597 43.8837209,36.8580198 C40.617757,36.3330863 37.7682351,34.4224427 35.804946,31.7837846 C39.0932617,28.2905273 41.3909912,24.9151611 42.0333252,21.2908936 C42.6756592,17.666626 42.4430846,11.664917 41.0167911,8.84170619 C42.4430846,8.30235848 44.0951795,8 46,8 C55.9432345,8 59,16.2389029 59,23.4186047 C59,29.8723938 54.2825949,35.8324226 48.1162791,36.8493729 C48.2813181,37.3738822 48.4828685,38.2378356 48.7209302,39.4412331 L46.9078625,39.4412331 L46.9078625,60 L45.0926542,60 L45.0926542,39.4412331 L43.2790698,39.4412331 Z M22.8604651,36.2783459 C23.1514183,34.886574 23.3839764,33.8930304 23.5581395,33.2977151 C16.4160928,32.1497847 11,25.2587449 11,17.7906977 C11,9.50642643 14.5270372,0 26,0 C37.4729628,0 41,9.50642643 41,17.7906977 C41,25.2373775 35.5568403,32.1143337 28.4418605,33.287738 C28.6322902,33.892941 28.8648483,34.8898103 29.1395349,36.2783459 L27.0475336,36.2783459 L27.0475336,60 L24.9530625,60 L24.9530625,36.2783459 L22.8604651,36.2783459 Z M23,3 C18.0032349,6.01678467 15.2982178,11.1021118 14,16 C12.9963379,10.0070801 18.504529,3 23,3 Z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "Line",
      "x": "0",
      "y": "67",
      "width": "70",
      "height": "3"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-282f05d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg/celebrate.vue
// module id = 604
// module chunks = 1